import { Divider } from "primereact/divider";
import { Panel } from "primereact/panel";
import { useTranslation } from "react-i18next";
import { Description } from "../../../components/Description";
import styles from "../../../components/ListDescriptions/styles.module.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

export function CadastralV({ cadastralV }: { cadastralV: any }) {
    const { t } = useTranslation();

    const formatarTelefone = (item: any) => {
        return `(${item.ddd}) ${item.telefone}`;
    };

    const formatarWhatsApp = (item: any) => {
        return item.whatsApp ? "Sim" : "Não";
    };

    const formatarNaoMePerturbe = (item: any) => {
        return item.naoMePerturbe ? "Sim" : "Não";
    };

    return (
        <Panel header={t("cadastral")}>

            {cadastralV && (
                <div>
                    <Divider align="left">
                        <div style={{ color: 'rgb(113, 113, 122)', fontSize: '1.5rem' }}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ stroke: 'currentColor', strokeLinejoin: 'round', strokeLinecap: 'round', strokeWidth: '2' }}><rect x="3" y="5" width="6" height="6" rx="1" /><path d="m3 17 2 2 4-4" /><path d="M13 6h8" /><path d="M13 12h8" /><path d="M13 18h8" /></svg>
                            <span style={{ paddingLeft: '0.5rem' }}>
                                <b>Informações cadastrais</b>
                            </span>
                        </div>
                    </Divider>
                    <div className={styles.wrapper}>
                        <div className={styles.gridContainer}>
                            <Description key={'nome'} label={'Nome'} value={cadastralV.nome} />
                            <Description key={'cpf'} label={'CPF'} value={cadastralV.cpf} />
                            <Description key={'nascimento'} label={'Nascimento'} value={cadastralV.dataNascimento} />
                            <Description key={'idade'} label={'Idade'} value={cadastralV.idade} />
                            <Description key={'mae'} label={'Mãe'} value={cadastralV.nomeMae} />
                            <Description key={'pai'} label={'Pai'} value={cadastralV.nomePai} />
                        </div>
                    </div>
                </div>
            )}

            {cadastralV?.emails && (
                <div>
                    <br></br>
                    <Divider align="left">
                        <div style={{ color: 'rgb(113, 113, 122)', fontSize: '1.5rem' }}>
                            <svg width="24" height="24" viewBox="0 0 24 20" fill="none" style={{ stroke: 'currentColor', strokeLinejoin: 'round', strokeLinecap: 'round', strokeWidth: '2' }}><rect width="20" height="16" x="2" y="4" rx="2" /><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" /></svg>
                            <span style={{ paddingLeft: '0.5rem' }}>
                                <b>E-mail</b>
                            </span>
                        </div>
                    </Divider>
                    <br></br>
                    <DataTable size="small" value={cadastralV.emails} tableStyle={{ minWidth: '50rem' }}>
                        <Column field="email" header={t('email')}></Column>
                    </DataTable>
                </div>
            )}

            {cadastralV?.telefones && (
                <div>
                    <br></br>
                    <Divider align="left">
                        <div style={{ color: 'rgb(113, 113, 122)', fontSize: '1.5rem' }}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ stroke: 'currentColor', strokeLinejoin: 'round', strokeLinecap: 'round', strokeWidth: '2' }}><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" /><path d="M14.05 2a9 9 0 0 1 8 7.94" /><path d="M14.05 6A5 5 0 0 1 18 10" /></svg>
                            <span style={{ paddingLeft: '0.5rem' }}>
                                <b>Telefones</b>
                            </span>
                        </div>
                    </Divider>
                    <br></br>
                    <DataTable size="small" value={cadastralV.telefones} tableStyle={{ minWidth: '50rem' }}>
                        <Column body={formatarTelefone} header={t('fone')}></Column>
                        <Column body={formatarWhatsApp} header="WhatsApp"></Column>
                        <Column body={formatarNaoMePerturbe} header="Não Perturbe"></Column>
                    </DataTable>
                </div>
            )}

            {cadastralV?.enderecos && (
                <div>
                    <br></br>
                    <Divider align="left">
                        <div style={{ color: 'rgb(113, 113, 122)', fontSize: '1.5rem' }}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ stroke: 'currentColor', strokeLinejoin: 'round', strokeLinecap: 'round', strokeWidth: '2' }}><path d="M15 22a1 1 0 0 1-1-1v-4a1 1 0 0 1 .445-.832l3-2a1 1 0 0 1 1.11 0l3 2A1 1 0 0 1 22 17v4a1 1 0 0 1-1 1z" /><path d="M18 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 .601.2" /><path d="M18 22v-3" /><circle cx="10" cy="10" r="3" /></svg>
                            <span style={{ paddingLeft: '0.5rem' }}>
                                <b>Endereços</b>
                            </span>
                        </div>
                    </Divider>
                    <br></br>
                    <DataTable size="small" value={cadastralV.enderecos} tableStyle={{ minWidth: '50rem' }}>
                        <Column field="logradouro" header={t('logradouro')}></Column>
                        <Column field="numero" header={t('numero')}></Column>
                        <Column field="complemento" header={t('complemento')}></Column>
                        <Column field="bairro" header={t('bairro')}></Column>
                        <Column field="cep" header={t('cep')}></Column>
                        <Column field="cidade" header={t('cidade')}></Column>
                        <Column field="uf" header={t('uf')}></Column>
                    </DataTable>
                </div>
            )}

        </Panel>
    );
}
